import { useState, useEffect } from 'react';
import api from '../api/axios';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export function usePush() {
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'denied'
  );
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator && permission === 'granted') {
      navigator.serviceWorker.ready.then(async (reg) => {
        const sub = await reg.pushManager.getSubscription();
        setSubscribed(!!sub);
      });
    }
  }, [permission]);

  const getSwRegistration = () => {
    return Promise.race([
      navigator.serviceWorker.ready,
      new Promise((_, reject) => setTimeout(() => reject(new Error('SW timeout')), 5000)),
    ]);
  };

  const subscribe = async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      alert('Ваш браузер не поддерживает push-уведомления');
      return;
    }
    setLoading(true);
    try {
      let reg;
      try {
        reg = await getSwRegistration();
      } catch {
        reg = await navigator.serviceWorker.register('/service-worker.js');
        await new Promise((r) => setTimeout(r, 1000));
      }

      let key = VAPID_PUBLIC_KEY;
      if (!key) {
        const res = await api.get('/push/vapidPublicKey');
        key = res.data.publicKey;
      }

      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      });

      await api.post('/push/subscribe', sub.toJSON());
      setSubscribed(true);
      setPermission('granted');
    } catch (err) {
      console.error('Push subscribe error:', err);
      if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
        alert('Уведомления заблокированы. Разрешите их в настройках браузера.');
      } else {
        alert('Не удалось подключить уведомления. Попробуйте перезапустить приложение.');
      }
    } finally {
      setLoading(false);
    }
  };

  const unsubscribe = async () => {
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) {
        await api.delete('/push/unsubscribe', { data: { endpoint: sub.endpoint } });
        await sub.unsubscribe();
      }
      setSubscribed(false);
    } catch (err) {
      console.error('Push unsubscribe error:', err);
    } finally {
      setLoading(false);
    }
  };

  return { permission, subscribed, loading, subscribe, unsubscribe };
}
